import {
  walk,
  getAncestors
} from '../util/treeUtils'

/**
 * Shows/hides nodes and parents matching search term
 *
 * @param {Array} shadowTree  - The shadow tree
 * @param {String} term       - String to search for
 */
export const applySearch = (shadowTree, term) => {
  const matches = []

  const re = new RegExp(`\\b${term.toLocaleLowerCase()}`)

  walk(shadowTree, node => {
    if (node === shadowTree[0]) return // Excluding root node

    // Search in all titles
    const foundTitle = re.exec(node.title.toLocaleLowerCase())

    // But only in values of leafs
    const foundValue = !node.isParent && re.exec(node.value.toLocaleLowerCase())

    if (foundTitle || foundValue) {
      matches.push(node)
      node.searchTermIndex = foundTitle ? foundTitle.index : node.title.length // Highlights term only if it occurs in the title, otherwise no point
    } else {
      node.searchTermIndex = -1
    }
  })

  // Hide/close all
  walk(shadowTree, node => {
    node.isShown = false
    if (node.isParent) node.isOpen = false
  })

  // Show matches and parent chains
  matches.forEach(node => {
    node.isShown = true
    if (node.isParent) node.isOpen = false

    getAncestors(shadowTree, node.path).forEach(parent => {
      parent.isOpen = true
      parent.isShown = true
    })
  })

  return matches
}
